import { itSoftwarePackages } from './pages/softwarePackages/it.softwarePackages';
import { contactUs } from '@helpers/staticImages/staticPages';

export const it = {
    notFound: {
        title: '404 pagina non trovata | Geotab',
        heading: 'Ops.',
        description: 'Non è stato possibile trovare la pagina che stavi cercando.',
        description2: 'Prova a cercare o torna alla',
        homepageLink: 'nostra homepage',
    },
    micrositeForm: {
        title: 'Entra nell\'ecosistema di Geotab',
        subTitle:
            'Scopri quanto e\' semplice utilizzare la nostra piattaforma e i dispositivi telematici per gestire la tua flotta',
        countryName: 'Italy',
        firstName: 'Nome',
        lastName: 'Cognome',
        company: 'Settore',
        email: 'Email',
        fleetSize: 'Dimensione della flotta',
        phone: 'Telefono',
        country: 'Paese',
        city: 'Città',
        state: 'Provincia',
        submitButton: 'Invia',
        tooltip: {
            pleaseFillOutThisField: 'Compila il campo',
            pleaseSelectAnItem: 'Seleziona un elemento dall\'elenco',
        },
    },
    salesforce: {
        formLanguage: 'Italian IT',
        demoFormDefaultCampaignId: '7012J000001YfkMQAS',
    },
    successStoriesHome: {
        seo: {
            title: 'Caso di studio e storie di successo | Geotab',
            description:
                'Scopri come il software di Fleet Management Geotab aiuta le aziende nel loro successo . Consulta i casi di studio sulla gestione delle flotte e le storie di successo sulla gestione GPS.',
        },
        filters: 'Filtri',
        header: 'Storie di successo',
        subHeader: 'Filtra per',
        sortBy: 'Ordina per',
        clearFilter: 'Cancella filtri',
        applyFilter: 'Applica filtri',
        results: 'Risultati',
        notResult:
            'Non riusciamo a trovare nessun contenuto che corrisponda a questo criterio. Prova a cambiare i filtri per ottenere più risultati',
        industry: 'Industria',
        region: 'Area geografica',
        fleetSize: 'Dimensione flotta',
        fleetFocus: 'Obiettivo della flotta:',
        fleets: 'flotta',
        fleetSizeFilterList: [
            { content: 'Tutta la', value: -1 },
            { content: 'Piccola', value: 0 },
            { content: 'Media', value: 1 },
            { content: 'Grande', value: 2 },
        ],
        fleetRegionFilterList: [
            { content: 'Tutta la', value: -1 },
            { content: 'Nord America', value: 0 },
            { content: 'America Latina', value: 1 },
            { content: 'Europa', value: 2 },
        ],
        fleetIndustryFilterList: [
            { content: 'Tutta la', value: -1 },
            { content: 'Trasporto passeggeri', value: 0 },
            { content: 'Edilizia', value: 1 },
            { content: 'Corrieri e spedizioni', value: 2 },
            { content: 'Field sales and services', value: 3 },
            { content: 'Food and beverage', value: 4 },
            { content: 'Pubblica amministrazione', value: 5 },
            { content: 'Petrolio e gas', value: 6 },
            { content: 'Farmaceutica', value: 7 },
            { content: 'Forze dell\'ordine e pronto intervento', value: 8 },
            { content: 'Noleggio', value: 9 },
            { content: 'Soccorso stradale', value: 10 },
            { content: 'Utility', value: 11 },
            { content: 'Trasporto rifiuti e riciclaggio', value: 12 },
            { content: 'Operazioni invernali', value: 13 },
            { content: 'Telecomunicazioni', value: 14 },
            { content: 'Trasporto', value: 15 },
        ],
        sortByFilterList: [
            { content: 'Più recente', value: 0 },
            { content: 'Meno recente', value: 1 },
            { content: 'Titolo', value: 2 },
        ],
    },
    successStoriesTemplate: {
        publishedOn: 'Pubblicato il',
        clientProfile: 'Profilo del cliente',
        name: 'Nome del cliente',
        industry: 'Settore',
        typesOfVehicles: 'Tipologia di veicoli',
        fleetSize: 'Dimensione della flotta',
        fleetFocus: 'Obiettivo della flotta',
        otherStories: 'Altre storie',
        optimizeYourFleet: 'Sei pronto a ottimizzare la tua flotta?',
        letUsShowYou:
            'Vogliamo mostrarti quanto è facile utilizzare la nostra piattaforma web MyGeotab e il dispositivo GO per gestire la tua flotta.',
        requestDemo: 'Richiedi una demo',
        requestDemoPath: '/it/richiedi-demo/',
        visitBlog: 'Visita il blog',
        downloadSuccessStory: 'Scarica il pdf',
    },
    transportationContactForm: {
        title: 'Ottimizza oggi stesso la tua flotta!',
        subTitle: 'Mettiti in contatto con noi e scopri come Geotab può soddisfare le tue necessità.',
        formField: {
            firstName: 'Nome',
            lastName: 'Cognome',
            company: 'Azienda',
            email: 'E-mail',
            phone: 'Telefono',
            selectCountry: 'Paese',
            city: 'Città',
            fleetSize: 'Fleet Size',
            consentTextSentences: [
                'Sì, desidero ricevere informazioni e comunicazioni su prodotti, servizi ed eventi Geotab. ',
                'Le tue informazioni saranno trattate in conformità con le ',
            ],
            consentLinkText: 'politiche sulla privacy di Geotab',
            consentTextEnding: '.',
            consentLink: 'https://docs.google.com/document/d/1-eYKZr2to3DL2ucstemhhvsqxgy-iEsnxsPzhEscWCs/edit#',
            submit: 'Invia',
        },
    },
    whitePapersHome: {
        seo: {
            title: 'Fleet Management White Paper | Geotab',
            description:
                'L’ultimo white paper di Geotab. Scopri come la soluzione fleet management di Geotab può aiutare la tua azienda',
        },
        page: 'Page',
        title: 'White papers',
    },
    whitePaper: {
        articleCard: {
            publishedOn: 'Pubblicato il',
            downloadWhitePaper: 'Scarica il white paper',
        },
        allWhitePapers: 'Tutti i white paper',
    },
    articleCard: {
        viewLink: 'Leggi il white paper',
    },
    readMore: 'Leggi di più',
    evLeadForm: {
        title: 'Ottimizza la tua flotta di veicoli elettrici',
        subTitle:
            'Compila il seguente modulo per richiedere una demo o per ricevere maggiori informazioni sulla gestione dei veicoli elettrici.',
        formField: {
            firstName: 'Nome',
            lastName: 'Cognome',
            company: 'Azienda',
            email: 'E-mail',
            selectCountry: 'Paese',
            city: 'Città',
            phone: 'Telefono',
            fleetSize: 'Dimensione flotta',
            identify: 'Aiutaci a identificare chi sei:',
            userType: {
                resellerType: 'Business Partner Geotab',
                newCustomerType: 'Nuovo cliente Geotab',
                existCustomerType: 'Cliente attuale Geotab',
            },
            consentTextSentences: [
                'Sì, desidero ricevere informazioni e comunicazioni su prodotti, servizi ed eventi Geotab. Le tue informazioni saranno trattate in conformità con le ',
            ],
            consentLinkText: 'politiche sulla privacy di Geotab',
            consentLink: 'https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub',
            submit: 'Invia',
        },
    },
    becomeInstaller: {
        seo: {
            title: 'Diventa un installatore | Geotab',
            description: 'Compila il modulo e diventa un installatore ufficiale Geotab',
        },
        title: 'Diventa un installatore',
        companyDetails: {
            title: 'Dettagli azienda',
            description1:
                'Inserire UNA sola domanda per ciascuna azienda. Se l\'azienda ha già presentato domanda e desideri sostenere il test di certificazione installatori, accedi a',
            takeTest: 'Esegui test',
            description2: 'e inserisci l\'ID assegnato all\'azienda.',
            takeTestLinkPath: 'application-test/',
        },
        stepOneForm: {
            companyName: 'Nome azienda',
            email: 'Indirizzo e-mail',
            website: 'Sito Web',
            phoneNumber: 'Telefono ',
            streetAddress: 'Indirizzo',
            city: 'Città',
            selectCountry: 'Paese',
            stateProvince: 'Stato/provincia',
            postalCode: 'Codice postale',
            next: 'Successivo',
        },
        stepTwo: {
            title: 'Domanda e contratto per installatori - Termini e condizioni',
            note: 'Nota: è necessario scorrere fino alla fine per abilitare l\'opzione Accetta',
            iAgree: 'Acconsento',
            back: 'Indietro',
            agreement: `1. Qualifica Installatore certificato: ai sensi dei presenti termini , al raggiungimento di tutti i requisiti di training, test e certificazione (i "Requisiti di certificazione") di volta in volta applicabili, da parte di almeno un membro del personale (ciascuno denominato "Persona certificata"), il soggetto sarà certificato e accetterà di operare in qualità di installatore certificato dei nostri prodotti (un "Installatore certificato Geotab") per fornire, attraverso le Persone certificate, i servizi di installazione, configurazione, programmazione, e di altra natura (i "Servizi installatore") a utenti o rivenditori dei nostri prodotti ("Utenti Geotab"). Ci riserviamo il diritto di certificare altri Installatori Geotab in qualsiasi area, a nostra esclusiva discrezione. Il soggetto è il solo responsabile delle transazioni con gli Utenti Geotab, delle eventuali spese sostenute in relazione a tali transazioni e di commissioni o altri crediti o debiti del soggetto. Il presente Contratto non concede al soggetto alcun diritto di vendere o rivendere i nostri prodotti o servizi automatizzati. Il soggetto non è autorizzato, senza previo consenso scritto, a fornire dichiarazioni o garanzie in relazione ai nostri prodotti o servizi, a decodificare o altrimenti modificare i nostri prodotti o a monitorare, intercettare o interferire con la trasmissione di dati a o da parte degli Utenti Geotab durante l’utilizzo dei nostri prodotti o servizi. È necessario disporre sempre di almeno una Persona certificata per mantenere il proprio stato di Installatore certificato Geotab. Qualora in un determinato momento il soggetto non disponesse di Persone certificate è tenuto a comunicarlo a Geotab che si riserva il diritto di sospendere la designazione come Installatore certificato Geotab fino a quando non verrà reintegrata nuovamente almeno una Persona certificata nello staff. Per i dispositivi telematici Geotab è consentito l’utilizzo di soli cablaggi approvati Geotab, acquisiti da un canale autorizzato Geotab . L'uso di cablaggi non approvati può causare gravi rischi per la sicurezza, tra cui incendi, con conseguenti lesioni personali gravi e/o danni al veicolo.
                        2. Durata e risoluzione: Il periodo iniziale ("Periodo iniziale") del presente Contratto decorre dalla data in cui il soggetto riceverà una conferma scritta che la sua richiesta è stata accettata e prosegue fino al giorno immediatamente precedente al terzo anniversario, salvo diversa risoluzione ai sensi del presente. Alla scadenza del Periodo iniziale o di qualsiasi Periodo di rinnovo, il Contratto verrà rinnovato automaticamente per i successivi periodi di un anno ciascuno (ciascuno un "Periodo di rinnovo" e, insieme al Periodo iniziale, il "Periodo"), salvo il caso in cui una delle parti non fornisca un avviso scritto di non rinnovo valido al termine del Periodo iniziale o del Periodo di rinnovo attuale, almeno 120 giorni prima della scadenza, oppure il presente Contratto venga altrimenti risolto ai sensi dello stesso. Entrambe le parti possono rescindere il presente Contratto in qualsiasi momento per qualsiasi motivo o per nessun motivo fornendo un preavviso scritto di 30 giorni all'altra parte. Qualsiasi inadempienza da parte del soggetto a soddisfare o continuare a soddisfare tutti i Requisiti di certificazione applicabili è considerata una violazione sostanziale del presente Contratto. Alla scadenza o alla cessazione del rapporto, tutte le informazioni e tutti i materiali devono essere restituiti.
                        3. Assicurazione: Durante il Periodo e per un periodo successivo di almeno due anni, il soggetto deve sottoscrivere e mantenere, in piena validità ed efficacia e a proprie spese, una polizza assicurativa generale o una polizza assicurativa generale completa con un massimale non inferiore a 2 milioni di dollari statunitensi per morte, lesioni personali, danni alla proprietà, responsabilità contrattuale, responsabilità operativa, danni alla pubblicità e responsabilità del prodotto, nonché qualsiasi altra responsabilità derivante o che si verifichi in relazione allo svolgimento dell’attività ai sensi di qualsivoglia accordo tra il soggetto e qualsiasi Utente Geotab. Tale polizza o polizze dovranno riportare Geotab tra gli altri assicurati e non potranno essere annullate o alterate senza un preavviso scritto di almeno 60 giorni a Geotab. Su richiesta, il soggetto deve fornire un certificato di tale assicurazione. La sottoscrizione di tale copertura assicurativa non esonera il soggetto dagli obblighi e responsabilità derivanti dal presente Contratto.
                        4. Dichiarazione di non responsabilità e limitazioni: GEOTAB DECLINA ESPRESSAMENTE OGNI DICHIARAZIONE, GARANZIA E CONDIZIONE, ESPLICITA O IMPLICITA, COMPRESE TUTTE LE DICHIARAZIONI, LE GARANZIE E LE CONDIZIONI DI QUALITÀ, PRESTAZIONI, COMMERCIABILITÀ, QUALITÀ COMMERCIALE, DURATA, IDONEITÀ PER UNO SCOPO PARTICOLARE, NON VIOLAZIONE DI DIRITTI ALTRUI DERIVANTI DA LEGGE O ALTRE NORMATIVE O DA UNA TRATTATIVA O UTILIZZO COMMERCIALE. IL SOGGETTO RISARCISCE E MANLEVA GEOTAB, I SUOI AGENTI, FORNITORI, DISTRIBUTORI, DISTRIBUTORI SECONDARI, RIVENDITORI O INCARICATI, I LORO RISPETTIVI DIRETTORI, FUNZIONARI, SHAREHOLDER E DIPENDENTI (CIASCUNO DENOMINATO "INDENNIZZATI"), DA E CONTRO EVENTUALI DANNI, COSTI, RESPONSABILITÀ, PERDITE E SPESE (INCLUSI COSTI E SPESE LEGALI RAGIONEVOLI) DERIVANTI O CORRELATI A EVENTUALI RECLAMI, RICHIESTE O AZIONI DI TERZE PARTI CHE UNA PARTE ASSICURATA POTREBBE SUBIRE O SOSTENERE IN RELAZIONE AD ATTIVITÀ COMMERCIALI, NEGLIGENZA O COMPORTAMENTO DOLOSO DEL SOGGETTO. IL SOGGETTO ACCETTA CHE, NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE APPLICABILE, IN NESSUN CASO, LA NOSTRA RESPONSABILITÀ NEI CONFRONTI DEL SOGGETTO SUPERERÀ L'IMPORTO PAGATO A GEOTAB INDICATO DI SEGUITO NEL MESE IMMEDIATAMENTE PRECEDENTE AL MOMENTO IN CUI È SORTO IL MOTIVO DELL'AZIONE E, IN NESSUN CASO, NESSUNA PARTE ASSICURATA SARÀ RESPONSABILE DI EVENTUALI DANNI O PERDITE CONSEGUENTI, INDIRETTE, ACCIDENTALI O SPECIALI, INCLUSA LA PERDITA DI RICAVI O PROFITTI, PERDITA DI DATI, INFORMAZIONI COMMERCIALI O PERDITA DI UTILIZZO DERIVANTE DA CIÒ, MANCATA REALIZZAZIONE DEI PROFITTI O RISPARMI PREVISTI, COSTI DEL CAPITALE, PERDITA DI ATTIVITÀ COMMERCIALI, PERDITA DELL'AVVIAMENTO O EVENTUALI PERDITE ECONOMICHE, COMMERCIALI, MONETARIE O INDIRETTE DI QUALSIASI TIPO O EVENTUALI RECLAMI DI TERZE PARTI, ANCHE NEL CASO IN CUI TALE PARTE ASSICURATA POTESSE PREVEDERE O SIA STATA AVVISATA DELLA POSSIBILITÀ DI EVENTUALI PERDITE O DANNI.
                        5. Proprietà intellettuale: Tutti i nomi commerciali, i nomi delle aziende, i marchi di fabbrica, i marchi di servizio, i nomi di dominio e altri nomi e loghi di prodotti e servizi sul nostro sito Web sono di proprietà di Geotab o dei suoi licenziatari e non possono essere utilizzati se non espressamente consentito nel presente documento. In base ai termini e alle condizioni del presente Contratto, concediamo al soggetto il diritto limitato, non trasferibile, non esclusivo e privo di royalty di utilizzare i nostri marchi espressamente identificati da Geotab come utilizzabili dagli Installatori certificati Geotab per commercializzare, promuovere, pubblicizzare e vendere i Servizi installatori. Il soggetto è tenuto a rispettare tutte le linee guida fornite da Geotab per quanto riguarda l'utilizzo da parte del soggetto. Geotab ha facoltà di verificare di volta in volta la conformità del soggetto in merito a tale utilizzo. Il soggetto comprende e accetta che qualsiasi feedback o input fornito a Geotab diventerà di nostra esclusiva proprietà . Il soggetto concede a Geotab il diritto limitato, non esclusivo e privo di royalty di utilizzare il nome e il logo aziendale per identificare e promuovere il soggetto come Installatore certificato Geotab e il soggetto accetta di fornire il proprio nome e le informazioni di contatto agli Utenti Geotab o ai potenziali Utenti Geotab in cerca di Servizi installatore.
                        6. Riservatezza: Il soggetto accetta che tutte le informazioni, scritte o orali, di natura proprietaria o riservata che Geotab divulga al soggetto saranno trattate come riservate. Il soggetto non divulgherà tali informazioni a terze parti e utilizzerà tali informazioni esclusivamente ai fini dell'adempimento dei propri obblighi ai sensi del presente Contratto. Il soggetto è tenuto a informarci tempestivamente di qualsiasi uso improprio, appropriazione indebita o divulgazione di informazioni riservate in violazione del presente Contratto,
                        7. Generale: (a) Comunicazioni. Il soggetto accetta di ricevere le comunicazioni di Geotab, inclusi gli avvisi di servizio, tramite e-mail e post sul nostro sito Web. Possiamo inoltre inviare avvisi tramite fax, posta, consegna personale o corriere all'indirizzo o al numero più recente fornito dal soggetto tramite il nostro sito Web. Ai sensi della presente disposizione, il soggetto può inviare comunicazioni tramite il nostro sito Web.. Il soggetto accetta che le richieste e le richieste legali a carico di Geotab debbano essere inviate tramite consegna personale, posta raccomandata o corriere a Geotab Inc., 21-1075 North Service Road West Oakville, ON, Canada L6M 2G2, ATTN: General Counsel o un altro indirizzo, che Geotab comunicherà di volta in volta ai sensi della presente disposizione. Qualsiasi avviso verrà considerato ricevuto: (i) se spedito tramite posta, dieci giorni lavorativi dopo la spedizione; (ii) se consegnato tramite corriere, tre giorni lavorativi dopo l'accettazione della consegna da parte del corriere; (iii) se consegnato personalmente il giorno della consegna, salvo dopo l'orario di lavoro, nel qual caso verrà considerato ricevuto il giorno lavorativo successivo; (iv) se consegnato tramite e-mail, il giorno lavorativo successivo alla trasmissione; e (v) se consegnato tramite il sito Web, il giorno effettivo in cui il sito Web conferma la consegna dell'avviso, salvo dopo l'orario lavorativo, nel qual caso verrà considerato consegnato il giorno lavorativo successivo. (b) Separabilità. Nella misura in cui qualsiasi parte del presente Contratto venga ritenuta non valida, illegale o non applicabile, tale parte sarà separata ed eliminata o limitata al fine di dare effetto, per quanto possibile, alle intenzioni delle parti (c) Forza maggiore. Geotab sarà esonerata dai propri obblighi derivanti del presente Contratto e declina ogni responsabilità nei confronti del soggetto o di terze parti qualora non sia possibile o non si riesca ad adempiere agli obblighi di cui al presente Contratto per cause che esulano dal nostro ragionevole controllo, per il tempo in cui tale causa impedisce a Geotab di agire. (d) Legge applicabile. Il presente Contratto sarà regolato e interpretato in conformità alle leggi della Provincia dell'Ontario. Il presente Contratto sarà considerato stipulato nella provincia dell'Ontario e il soggetto si impegna a sottoporsi alla giurisdizione non esclusiva dei tribunali della provincia dell'Ontario. (e) Rinunce. Nessuna rinuncia di una delle parti in seguito a qualsiasi violazione dell'altra parte delle clausole, degli obblighi e degli accordi qui descritti rappresenta la rinuncia a qualsiasi violazione successiva di qualsivoglia pattuizione, obbligo o accordo, né l’eventuale disponibilità a ricercare un rimedio alla violazione rappresenterà una rinuncia verso eventuali diritti e rimedi relativi a qualsiasi violazione attuale o futura. (f) Contraenti indipendenti . Nulla di quanto contenuto nel presente documento sarà considerato o interpretato dal soggetto, da Geotab o da terze parti come l’instaurarsi di un rapporto di partnership o joint venture o un rapporto tra capo e agente, datore di lavoro-dipendente, padrone-servitore o affiliante-affiliato tra il soggetto e Geotab. Fatto salvo quanto espressamente stabilito nel presente Contratto, nessuna parte ha facoltà di a vincolare l'altra in alcun modo. (g) Assegnazione e subappalto. Il soggetto può subappaltare o delegare i propri obblighi ai sensi del presente Contratto, a condizione che il subappalto o la delega riguardino esclusivamente un altro Installatore certificato Geotab; inoltre il soggetto sarà responsabile di tutti gli atti o le omissioni di coloro a cui è stato concesso il subappalto o la delega, come se tali atti od omissioni fossero suoi, incluse eventuali violazioni del presente Contratto. Il soggetto è tenuto a garantire che tali appaltatori o delegati rispettino le disposizioni applicabili del presente Contratto, inclusa, in via non esaustiva, la fornitura della copertura assicurativa. Geotab si riserva il diritto di assegnare tale Contratto o eventuali diritti od obblighi ivi presenti in modo totale o parziale. Il soggetto non può cedere o trasferire il presente Contratto o qualsiasi diritto o obbligo ai sensi del presente Contratto, ivi compresa l'esecutività del diritto. (h) Accordo completo. Il Contratto contiene l'intero accordo tra il soggetto e Geotab relativo al riconoscimento della qualifica di Installatore certificato Geotab e sostituisce tutti i precedenti accordi tra il soggetto e Geotab relativi allo stesso. Non vi sono dichiarazioni, garanzie, termini, condizioni, impegni o accordi collaterali, espressi, impliciti o legali, tra il soggetto e Geotab oltre a quanto espressamente stabilito nel presente Contratto.`,
        },
        stepThree: {
            review: 'Conferma le informazion',
            companyDetails: 'Dettagli azienda',
            confirm: 'Conferma',
            cancel: 'Annulla',
            editDetails: 'Modifica informazioni',
            takeTest: 'Esegui il test',
            thankYou: 'Grazie! La richiesta è stata inviata.',
            uniqueKey: 'Alla tua azienda è stato assegnato l’ID',
            reviewText:
                'Il soggetto è tenuto a rivedere le informazioni fornite in precedenza e assicurarsi che siano vere, accurate, complete e corrette. Qualora fosse necessario apportare delle modifiche, farlo prima di procedere. Il soggetto prende atto e comprende che Geotab si riserva il diritto di rifiutare la domanda o, in seguito all\'accettazione, di rescindere il Contratto e/o sospendere lo stato del soggetto come Installatore certificato Geotab, qualora si riscontrasse che qualsivoglia informazione o documentazione fornita unitamente alla domanda non sia vera, accurata, completa o aggiornata. Facendo clic su "Conferma", il soggetto: (a) inoltra a Geotab la domanda e le informazioni sopra riportate; (b) dichiara, garantisce e pattuisce di avere l\'autorità per vincolare l\'entità sopra indicata, che le informazioni fornite sono vere, accurate, attuali e complete e che, in qualità di rappresentante dell\'entità sopra indicata, accetta i termini e le condizioni sopra riportati. Qualora non si accettino i termini e le condizioni o non si intenda procedere con la domanda, non fare clic su "Conferma" di seguito. Fare clic su "Annulla" qui di seguito per annullare la propria domanda.',
            note: 'Per completare il processo di richiesta, invia la prova di assicurazione e il logo aziendale all\'indirizzo installcert@geotab.com. Almeno una persona della tua azienda deve sostenere e superare il test di certificazione per gli installatori',
        },
        stepLabels: {
            'Company details': 'Dettagli dell\'azienda',
            'Terms and agreement': 'Termini',
            Confirmation: 'Revisione',
        },
    },
    authorBiography: {
        authorOverview: {
            leanMoreAbout: 'Scopri di più su {authorName}',
        },
        authorPosts: {
            postsBy: 'Post di',
            postBy: 'Post di',
            noPostAvailable: 'Nessun post',
        },
        geotabSubscribe: {
            subscribeTo: 'Iscriviti al blog di Geotab',
            description:
                'Segui ogni mese le notizie e i suggerimenti più importanti dal settore flotte. Puoi cancellare l\'iscrizione al blog in qualsiasi momento.',
        },
        subscribeForm: {
            subscribe: 'Iscriviti',
            email: 'Indirizzo e-mail *',
        },
        subscribeFormMC: {
            subscribe: 'Iscriviti',
            firstName: 'Nome',
            lastName: 'Cognome',
            email: 'E-Mail',
            formId: 'eu-blog-global',
            consentTextSentences:
                'Sì, desidero ricevere comunicazioni di marketing relative a prodotti, servizi ed eventi Geotab.com. Le informazioni utente verranno utilizzate in conformità con ',
            consentLinkText: 'l\'informativa sulla privacy di Geotab.',
            consentLink:
                'https://docs.google.com/document/d/1-eYKZr2to3DL2ucstemhhvsqxgy-iEsnxsPzhEscWCs/edit#heading=h.gjdgxs',
        },
        errors: {
            emailOnList: 'L\'e-mail era già nella nostra lista, controlla lo stato della tua iscrizione qui:',
            unsubscribed:
                'L\'e-mail è stata precedentemente annullata, contatta il nostro amministratore per essere aggiunto di nuovo.',
            error: 'Si è verificato un errore, riprova più tardi o contatta l\'amministratore.',
        },
    },
    pressRelease: {
        publishedOn: 'Pubblicato il',
        mediaContact: {
            title: 'Contatto stampa',
            email: 'pr@geotab.com',
            imageAlt: 'Un grafico che mostra un megafono bianco.',
        },
    },
    aboutGeotab: {
        main: 'Informazioni su Geotab',
        content:
            'Geotab è leader mondiale nelle soluzioni per il trasporto connesso, abilitando  una migliore e più efficiente gestione delle flotte. Utilizziamo l\'analisi avanzata dei dati e l\'intelligenza artificiale per migliorare le prestazioni, la sicurezza e la sostenibilità delle flotte, contribuendo al contempo a ridurne i costi e a favorirne l\'efficienza. Con il supporto dei migliori data scientist e tecnici professionisti, siamo in grado di aiutare oltre 55.000 clienti in tutto il mondo, elaborando 80 miliardi di dati al giorno, relativi a oltre 4,7 milioni di veicoli connessi. Geotab è un partner di riferimento per numerose organizzazioni, tra cui aziende nella classifica Fortune 500,  ma anche realtà di medie dimensioni e le più importanti flotte del settore pubblico al mondo, compreso il governo federale degli Stati Uniti. Grazie al nostro impegno nel garantire la sicurezza e la privacy dei dati, abbiamo conseguito le certificazioni FIPS 140-3 e FedRAMP. La piattaforma aperta di Geotab, il nostro ecosistema di partner e il Marketplace offrono inoltre centinaia di soluzioni di terze parti. Quest\'anno festeggiamo 25 anni di innovazione. Per ulteriori informazioni, visita il sito <a href="https://www.geotab.com/it/" target="_blank">www.geotab.com/it</a>, seguici su <a href="https://www.linkedin.com/company/geotab/" target="_blank" rel="noopener noreferrer">LinkedIn</a> o consulta il nostro <a href="https://www.geotab.com/it/blog/" target="_blank">blog</a>.',
        rights: 'Tutti i diritti riservati.',
        disclaimer:
            'Il presente documento intende fornire informazioni e stimolare la discussione su argomenti di interesse per la comunità telematica. Geotab non intende fornire consulenza tecnica, professionale o legale attraverso il presente documento. Nonostante sia stato fatto ogni sforzo possibile per garantire che le informazioni contenute nel presente documento siano puntuali e accurate, sono comunque possibili errori e omissioni e le informazioni qui riportate potrebbero risultare non aggiornate con il passare del tempo.',
    },
    recentNews: 'Notizie recenti',
    relatedPosts: 'Post correlati',
    salesInquiries: {
        seo: {
            title: 'Richiesta informazioni di vendita | Geotab',
            description:
                'Per domande o commenti sull\'acquisto di uno dei nostri prodotti o soluzioni, compila il modulo sottostante.Ti contatteremo al più presto.',
        },
        heroImagePath: contactUs.salesInquiryHeroImage,
        title: 'Richiesta informazioni di vendita',
        header: 'Contatta il dipartimento vendite',
        subtext:
            'Per domande o commenti sull\'acquisto di uno dei nostri prodotti o soluzioni, compila il modulo sottostante.Ti contatteremo al più presto.',
        inquiryType: 'Sales',
    },
    contactUsForm: {
        firstName: 'Nome',
        lastName: 'Cognome',
        phone: 'Telefono',
        email: 'E-mail',
        company: 'Azienda',
        fleetSize: 'Dimensione della flotta',
        country: 'Paese',
        city: 'Città',
        comments: 'Domande/commenti:',
        checkboxText:
            'Sì, desidero ricevere comunicazioni di marketing relative a prodotti, servizi ed eventi Geotab.com. Le informazioni utente verranno utilizzate in conformità con l\'informativa sulla privacy di Geotab.',
        submit: 'Invia',
        languageCode: 'Italian IT',
        consentTextEU:
            'Vuoi ricevere comunicazioni di marketing relative a prodotti, servizi ed eventi Geotab? Le tue informazioni saranno utilizzate in conformità con la <a href="https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub" target="_blank">Privacy Policy</a> di Geotab.',
        yes: 'Sì',
        no: 'No',
    },
    resellerForm: {
        seo: {
            title: 'Richiesta per diventare Business Partner | Geotab',
            description:
                'Vuoi diventare un Business Partner Geotab? Compila il modulo sottostante e ti contatteremo il prima possibile.',
        },
        heroImagePath: contactUs.resellerSupport,
        title: 'Richiesta per diventare Business Partner',
        header: 'Contatta il supporto Business Partner',
        subtext:
            'Vuoi diventare un Business Partner Geotab? Compila il modulo sottostante e ti contatteremo il prima possibile.',
        inquiryType: 'Become a Reseller/Partner',
    },
    generalInquiries: {
        seo: {
            title: 'Domande generali | Geotab',
            description: 'Hai una domanda? Compila il modulo sottostante e ti contatteremo il prima possibile.',
        },
        heroImagePath: contactUs.generalInquiriesHeroImage,
        title: 'Domande generali',
        header: 'Contattaci',
        subtext: 'Hai una domanda? Compila il modulo sottostante e ti contatteremo il prima possibile.',
        inquiryType: 'Other',
    },
    contactGeneralInquiry: {
        formField: {
            fullName: 'nome e cognome',
            company: 'Azienda',
            email: 'E-mail',
            selectFleetSize: 'Seleziona una dimensione della flotta',
            phone: 'Telefono',
            selectCountry: 'inserisci un settore\u2026',
            city: 'Città',
            comments: 'Domande/commenti:',
            submit: 'Invia',
        },
    },
    pressRoomHome: {
        seo: {
            title: 'Area stampa',
            description:
                'Consulta le ultime notizie sulla telematica e il Fleet Management e le novità di Geotab nell\'Area stampa Geotab',
        },
        allPressReleases: 'Tutti i comunicati stampa',
        pressKit: {
            pressKitTitle: 'Press kit',
            ourAvailableResources:
                'Le nostre risorse disponibili per i giornalisti. Per le domande dei media, invia un\'e-mail a ',
            pressKitList: [
                {
                    name: 'Profilo aziendale',
                    url: '/it/chi-siamo/',
                    image: 'icon-corporate-profile.svg',
                },
                {
                    name: 'Biografie dei manager ',
                    url: '/about/leadership/',
                    image: 'icon-leadership-bios.svg',
                },
                {
                    name: 'Scheda informativa',
                    url: 'https://docs.google.com/document/d/1Bct3-Z9FCtl15C7DS8iGWtoE7Ckc6IgvRbv9cRqmYFw/edit?usp=sharing',
                    image: 'icon-media-guidelines.svg',
                },
            ],
        },
        pressRoomSectionListCards: {
            latestUpdates: 'Ultimi aggiornamenti',
            inOtherNews: 'In altre notizie',
        },
    },
    pagination: {
        page: 'Pagina',
        of: 'di',
    },
    articleTypes: {
        pressRelease: 'Comunicati stampa',
        caseStudy: 'Storie di successo',
        blog: 'Blog',
        whitePaper: 'White paper',
        video: 'Video',
    },
    articleTypesAction: {
        viewAll: 'Mostra tutto',
        filter: 'Filtro',
    },
    myGeotabLogin: {
        loginText: 'Accedi',
        registerText: 'Registrati',
        newsText: 'Notizie in primo piano',
        seo: {
            title: 'MyGeotab Accedi / Registrati | Italia | Geotab',
            description:
                'Accedi in modo sicuro alla dashboard di MyGeotab. Non hai un account? Registrati come nuovo utente in Italia.',
        },
        heading: 'Italia Accedi / registrati a MyGeotab',
    },
    blogHome: {
        seo: {
            title: 'Blog Geotab | Blog sul Fleet Management | Geotab',
            description:
                'Scopri gli ultimi aggiornamenti e le tecnologie più all’avanguardia nel settore del Fleet Management | Blog sul Fleet Management',
        },
        featured: 'In primo piano',
        browseCategories: 'Sfoglia le categorie',
        editorsPicks: 'La nostra scelta',
        newestPosts: 'Post più recenti',
        viewAll: 'Tutti i blog post',
        mostRecent: 'Più recenti',
    },
    categories: {
        all: 'Tutti',
        allCategoriesTitleTag: 'Vedi tutti i post',
        categoriesTitleTag: 'Vedi post in',
        geotabAuthor: 'Autore di Geotab',
        page: 'Pagina',
        fleetManagementBlog: 'Blog sul Fleet Management',
    },
    blogPost: {
        publishedOn: 'Pubblicato il',
        updatedOn: 'Ultimo aggiornamento il',
        categoryIn: 'in',
        category: 'categoria',
        publishedBy: 'da',
        relatedPosts: 'Post correlati',
        likeButtonText: 'Se ti è piaciuto questo post, faccelo sapere!',
        likeButtonAriaText: 'Like',
        disclaimerTitle: 'Dichiarazione di non responsabilità',
        disclaimerSummary:
            'I blog post di Geotab hanno l’obiettivo di fornire informazioni e stimolare la discussione su argomenti di interesse per la comunità telematica. Geotab non intende fornire consulenza tecnica, professionale o legale attraverso tali post. Nonostante sia stato fatto il possibile per garantire che le informazioni contenute siano puntuali e accurate, sono comunque possibili errori e omissioni, e le informazioni qui riportate potrebbero risultare non aggiornate con il passare del tempo.',
        share: 'Condividere',
        shareArticle: 'Condividere articolo',
        copyUrl: 'Copiare URL',
        copiedUrlMessage: 'Copiato',
        shareWith: 'Condividere via',
        keyInsights: 'Approfondimenti',
    },
    renderChips: {
        postTags: 'Tag del post',
        tag: 'tag',
    },
    siteWideDemoForm: {
        formField: {
            firstName: 'Nome',
            lastName: 'Cognome',
            company: 'Azienda',
            title: 'Ruolo',
            email: 'E-mail',
            industry: 'Settore',
            fleetSize: 'Seleziona una dimensione della flotta',
            phone: 'Telefono',
            country: 'Seleziona il paese...',
            state: 'Regione',
            city: 'Città',
            selfAttribution: 'Come hai sentito parlare di noi?',
            multipleRegionText: 'La tua azienda è presente in più paesi? (Opzionale)',
            consentText:
                'Sì, desidero ricevere comunicazioni di marketing relative a prodotti, servizi ed eventi Geotab.com. Le informazioni utente verranno utilizzate in conformità con <a href="https://docs.google.com/document/d/1-eYKZr2to3DL2ucstemhhvsqxgy-iEsnxsPzhEscWCs/edit#heading=h.gjdgxs">l\'informativa sulla privacy</a> di Geotab.',
        },
        helperText: {
            forceMultiPick: 'Seleziona almeno due opzioni',
        },
        returnToPrevious: 'Indietro',
        a11yInstructions:
            'Il form è composto da più pagine, per passare alla pagina successiva compila i seguenti campi o spunta le caselle.',
    },
    requestDemo: {
        optimizeYourFleetToday: 'Ottimizza la tua flotta oggi',
        formField: {
            leadSource: 'Geotab Demo Form',
            firstName: 'Nome',
            lastName: 'Cognome',
            company: 'Azienda',
            email: 'E-mail',
            selectFleetSize: 'Seleziona una dimensione della flotta',
            phone: 'Telefono',
            selectCountry: 'Seleziona il paese\u2026',
            city: 'Città',
            selfAttribution: 'Come hai sentito parlare di noi?',
            consentText:
                'Sì, desidero ricevere comunicazioni di marketing relative a prodotti, servizi ed eventi Geotab.com. Le informazioni utente verranno utilizzate in conformità con <a href="https://docs.google.com/document/d/1-eYKZr2to3DL2ucstemhhvsqxgy-iEsnxsPzhEscWCs/edit#heading=h.gjdgxs" rel="noopener" target="_blank">l\'informativa sulla privacy</a> di Geotab.',
            requestAFreeDemo: 'Richiedi una demo gratuita',
        },
    },
    softwarePackages: itSoftwarePackages,
    formPlaceholders: {
        firstNamePlaceholder: 'Inserisci un nome\u2026',
        lastNamePlaceholder: 'Inserisci un cognome\u2026',
        companyPlaceholder: 'inserisci un settore\u2026',
        emailPlaceholder: 'inserisci una e-mail\u2026',
        fleetPlaceholder: 'Seleziona una dimensione della flotta\u2026',
        phonePlaceholder: 'Inserisci un telefono\u2026',
        countryPlaceholder: 'Seleziona il paese\u2026',
        cityPlaceholder: 'Inserisci una città\u2026',
        commentsPlaceholder: 'Inserisci domande/commenti\u2026',
        fullNamePlaceholder: 'Immettere un nome completo\u2026',
        identityPlaceholder: 'Seleziona una categoria\u2026',
        messagePlaceholder: '',
        surnamePlaceholder: 'Inserisci un cognome\u2026',
        statePlaceholder: '',
        provincePlaceholder: '',
        titlePlaceholder: 'Selezionare il tuo ruolo\u2026',
        userTitlePlaceholder: 'Inserire il tuo ruolo qui\u2026',
        clientPlaceholder: 'Per favore aiutaci a identificarti\u2026',
        industryPlaceholder: 'Selezionare una categoria di settore\u2026',
        subIndustryPlaceholder: 'Selezionare una categoria di sottosettore\u2026',
        selfAttributionPlaceholder: 'Dicci come sei venuto a conoscenza di Geotab\u2026',
    },
    formTranslations: {
        firstName: 'Nome',
        lastName: 'Cognome',
        company: 'Azienda',
        email: 'E-mail',
        phone: 'Telefono',
        city: 'Città',
        country: 'Nazione',
        interest: 'Area d\'interesse',
        industry: 'Settore',
        subIndustry: 'Sottosettore',
        client: 'Tipo di cliente',
        fleetSize: 'Dimensioni della flotta',
        submit: 'Invia',
        yes: 'Sì',
        no: 'No',
        yesToProceed: 'Seleziona Sì dall\'alto per procedere',
        checkedToProceed: 'Si prega di spuntare la casella di controllo sopra per procedere',
        state: 'Regione',
        province: 'Provincia',
        title: 'Ruolo',
        userTitle: 'Il tuo ruolo',
        forceMultiPick: 'Seleziona almeno due opzioni',
    },
    findInstaller: {
        title: 'Trova l\'installatore autorizzato Geotab più vicino a te',
        searchPlaceholder: 'Cerca per Nome, Città, Stato/Provincia, Paese, Livello di competenza',
    },
    securityForm: {
        formField: {
            fullName: 'Nome e cognome',
            email: 'E-mail',
            message: 'Messaggio',
        },
        submit: 'Invia',
        thankYou: 'Grazie, il nostro team Security ti contatterà al più presto.\u00A0',
    },
    regionSelection: {
        seo: {
            title: 'Seleziona il Paese',
            description:
                'Seleziona il tuo paese o regione per conoscere il software di gestione della flotta e i dispositivi di localizzazione dei veicoli di Geotab.',
        },
        title: 'Seleziona la tua regione',
        regions: {
            northSouthAmerica: 'Nord America e Sud America',
            europe: 'Europa',
            asiaAustraliaMiddleEast: 'Asia, Australia e Medio Oriente',
        },
        regionChangeText: 'Cambia lingua',
    },
    search: {
        seo: {
            title: 'Risultati di ricerca su',
        },
        search: 'Cerca',
        searchBarPlaceholder: 'Cerca argomenti, articoli, documenti e altro ancora.',
        searchResultsPrefix: true,
        searchResults: 'Risultati di ricerca su',
        showing: 'Mostra',
        of: 'su',
        results: 'risultati',
        noResults: {
            sorryMessage: 'Ci dispiace, non abbiamo trovato risultati su',
            invalidSearch: 'Spiacenti, il tuo input di ricerca non è valido.',
            searchTips: 'Suggerimenti di ricerca',
            spellingCheck: 'Controlla l\'ortografia e prova di nuovo.',
            simplerTerms: 'Cerca parole chiave più semplici e corte.',
            lessSpecific: 'Cerca qualcosa di meno specifico.',
            differentWords: 'Prova con parole chiave diverse o seleziona un intervallo di date differente.',
        },
        filter: {
            contentType: 'Tipo di contenuto',
            filterButtonText: 'Filtro',
            applyFilters: 'Applica filtri',
            clearFilters: 'Rimuovi filtri',
        },
        dateSelection: {
            dateUpdated: 'Data aggiornata',
            all: 'Tutti',
            30: 'Ultimi 30 giorni',
            90: 'Ultimi 90 giorni',
            365: 'Utimo anno',
        },
    },
    entityHomeNames: {
        blogArticle: 'Blog',
        pressReleaseArticle: 'Area stampa',
        whitePaperArticle: 'White paper',
        successStoryArticle: 'Storie di successo',
        glossaryArticle: 'Glossario',
    },
    entityNames: {
        blogArticle: 'Blog post',
        pressReleaseArticle: 'Comunicati stampa ',
        whitePaperArticle: 'White paper',
        successStoryArticle: 'Storie di successo',
        page: 'Pagina',
        author: 'Autore',
        category: 'Categoria',
        tag: 'Tag',
        video: 'Video',
        document: 'Documento',
        glossaryArticle: 'Glossario',
    },
    blogTableContent: {
        title: 'Sommario',
    },
    articleFAQ: {
        title: 'Domande frequenti',
    },
    glossary: {
        articleCard: {
            keyTakeaways: 'In breve',
        },
    },
    blogInfo: {
        readMinutes: '5 minuti di lettura',
        by: 'Da',
    },
    noBlogsFound: {
        forAuthor: 'Nessun blog post trovato per',
        forCategory: 'Nessun blog post trovato per',
        forTag: 'Nessun resultado trovato tramite il tag',
        noArticlesFound: 'Nenhum resultado encontrado! Imposta un nuovo filtro.',
    },
    aboutAuthor: {
        about: 'Su',
        currentRole: 'Ruolo attuale',
        experties: 'Esperienza lavorativa',
        accomplishments: 'Risultati',
        education: 'Istruzione',
        publications: 'Pubblicazioni',
    },
    mobileStickyBanner: {
        text: 'Richiedi una demo',
        link: '/it/richiedi-demo/',
    },
    breadcrumb: {
        home: 'Home',
    },
    contactSection: {
        title: 'CONTATTACI',
        subHeading: 'Dove possiamo inoltrare la tua richiesta?',
        salesInquiryText: 'Richiesta informazioni commerciali',
        salesInquiryImageAlt: 'Price tag icon',
        salesInquiryLink: '/it/contattaci/informazioni-di-vendita/',
        customerSupportText: 'Assistenza clienti',
        customerSupportImageAlt: 'Customer chat icon',
        customerSupportLink: 'https://support.geotab.com/it-IT',
        contactLinks: [
            {
                title: 'Richiedi una demo',
                href: 'https://www.geotab.com/it/richiedi-demo/',
            },
            {
                title: 'Diventa un Business Partner',
                href: 'https://www.geotab.com/it/contattaci/diventa-business-partner/',
            },
        ],
    },
};
